
import SimpleLightbox from "simplelightbox";
import "simplelightbox/dist/simple-lightbox.min.css";

const galleryCont = document.querySelector('.gallery');
const loader = document.querySelector('.loader');
let lightbox = new SimpleLightbox('.gallery a', {
    captionsData: 'alt',
    captionDelay: 250,
});
export function createGallery(images) {
    const markup = images
    .map(
        ({ webformatURL, largeImageURL, tags, likes, views, comments, downloads}) =>
            `<li class="gallery-item">
                <a class="gallery-link" href="${largeImageURL}">
                    <img class="gallery-image" src="${webformatURL}" alt="${tags}"/>
                    <div class="info">
                      <p><b>Likes:</b> ${likes}</p>
                      <p><b>Views:</b>${views}</p>
                      <p><b>Comments:</b>${comments}</p>
                      <p><b>Downloads:</b>${downloads}</p>
                    </div>
                </a>
            </li>`
    )
    .join('');
    galleryCont.insertAdjacentHTML('beforeend', markup);
    lightbox.refresh();
}
export function clearGallery() {
    galleryCont.innerHTML = '';
}

export function showLoader() {
    loader.classList.remove('is-hidden');
}
export function hideLoader() {
    loader.classList.add('is-hidden');
}